function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { toast } from "react-toastify";
// Customizable Area End

export const configJSON = require("./config");
export default class ShiftManagementController extends BlockComponent {
  // Customizable Area Start

  // Customizable Area End

  constructor(props) {
    super(props);
    // Customizable Area Start
    _defineProperty(this, "showErrorToast", resObj => {
      if (resObj.message) {
        resObj.status !== 200 ? toast.error(resObj.message) : toast.success(resObj.message);
      }
    });
    _defineProperty(this, "handleDrawer", () => {
      this.clearFormState();
      this.setState({
        drawer: !this.state.drawer
      });
    });
    _defineProperty(this, "handleStartTime", event => {
      this.setState({
        startTime: event.target.value,
        isStartTimeValid: true,
        startTimeErrorMessage: ""
      });
    });
    _defineProperty(this, "handleEndTime", event => {
      this.setState({
        endTime: event.target.value,
        isEndTimeValid: true,
        endTimeErrorMessage: ""
      });
    });
    _defineProperty(this, "validateTimings", () => {
      this.setState({
        disableShiftBtn: true
      });
      let apiError = false;
      if (this.state.startTime === "") {
        apiError = true;
        this.setState({
          isStartTimeValid: false,
          startTimeErrorMessage: "Field cannot be blank.",
          disableShiftBtn: false
        });
      }
      if (this.state.endTime === "") {
        apiError = true;
        this.setState({
          isEndTimeValid: false,
          endTimeErrorMessage: "Field cannot be blank.",
          disableShiftBtn: false
        });
      }
      if (!apiError && this.state.isStartTimeValid && this.state.isEndTimeValid) {
        this.setState({
          loading: true
        });
        let data = {
          shift: {
            start_time: this.state.startTime,
            end_time: this.state.endTime
          }
        };
        this.createShift(data);
      }
    });
    _defineProperty(this, "createShift", data => {
      const httpBody = data;
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.createShiftApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.createShiftApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "POST");
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "clearFormState", () => {
      this.setState({
        startTime: "",
        endTime: "",
        isStartTimeValid: true,
        isEndTimeValid: true,
        startTimeErrorMessage: "",
        endTimeErrorMessage: ""
      });
    });
    _defineProperty(this, "getAllShifts", () => {
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.getAllShiftApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.getAllShiftsApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "resetShifts", () => {
      this.setState({
        loading: true
      });
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.resetShiftApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.resetShiftApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "DELETE");
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "createShiftApiCall", responseJson => {
      if (responseJson.data) {
        if (Object.keys(responseJson.data.length !== 0)) {
          toast.success("Shift created successfully.");
          this.clearFormState();
          this.getAllShifts();
          this.setState({
            drawer: !this.state.drawer,
            disableShiftBtn: false
          });
        } else {
          this.setState({
            loading: false,
            drawer: !this.state.drawer,
            disableShiftBtn: false
          });
        }
      } else {
        this.setState({
          loading: false,
          drawer: !this.state.drawer,
          disableShiftBtn: false
        });
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong.");
        }
      }
    });
    _defineProperty(this, "getAllShiftsApiCall", responseJson => {
      if (responseJson.data) {
        if (responseJson.data.length !== 0) {
          let tempArr = [];
          let response = responseJson.data;
          let number = 0;
          response.map((_data, idx) => {
            number = number + 1;
            tempArr.push({
              cardNumber: number,
              id: _data.id,
              startTime: _data.attributes.start_time,
              endTime: _data.attributes.end_time
            });
          });
          this.setState({
            shiftData: tempArr,
            loading: false
          });
        } else {
          this.setState({
            loading: false,
            shiftData: responseJson.data
          });
        }
      } else {
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong.");
        }
        this.setState({
          loading: false
        });
      }
    });
    _defineProperty(this, "resetShiftApiCall", responseJson => {
      if (responseJson.message) {
        this.showErrorToast(responseJson);
      } else {
        toast.error("Something went wrong.");
      }
      if (responseJson.status === 200) {
        this.getAllShifts();
      } else {
        this.setState({
          loading: false,
          shiftData: responseJson.data
        });
      }
    });
    this.receive = this.receive.bind(this);
    // Customizable Area Start
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage), getName(MessageEnum.SessionResponseMessage), getName(MessageEnum.CountryCodeMessage)];
    this.state = {
      drawer: false,
      loading: false,
      startTime: "",
      endTime: "",
      isStartTimeValid: true,
      isEndTimeValid: true,
      startTimeErrorMessage: "",
      endTimeErrorMessage: "",
      shiftData: [],
      disableShiftBtn: false
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this, this.subScribedMessages);
  }
  async receive(from, message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (apiRequestCallId === this.createShiftApiCallId) {
        this.createShiftApiCall(responseJson);
      }
      if (apiRequestCallId === this.getAllShiftApiCallId) {
        this.getAllShiftsApiCall(responseJson);
      }
      if (apiRequestCallId === this.resetShiftApiCallId) {
        this.resetShiftApiCall(responseJson);
      }
    }
    // Customizable Area End
  }

  async componentDidMount() {
    this.setState({
      loading: true
    });
    this.getAllShifts();
  }

  // Customizable Area End
}